import React from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import MButton from '../../../common/MButton'

const BookingTableModal = (props) => {
    const { open = false, titleText = '', onClose = () => { }, data = [], handleLoad = () => { } } = props
    const columnDef = [
        { headerName: 'PNR\nNo.', field: 'BookingID', headerSx: { textAlign: 'left', width: '100px' }, sortable: true },
        { headerName: 'Ticket\nNo.', field: 'TicketNo', headerSx: { textAlign: 'left', width: '100px' }, sortable: true },
        { headerName: 'Passenger\nName', field: 'PassengerName', headerSx: { textAlign: 'left', }, sortable: true },
        { headerName: 'Booked\nDate', field: 'BookingDate', headerSx: { textAlign: 'left', width: '100px' }, sortable: true },
        { headerName: 'Journey\nDate', field: 'JourneyDate', headerSx: { textAlign: 'left', width: '100px' }, sortable: true },
        { headerName: 'Collect\nAmount', field: 'TotalFare', headerSx: { textAlign: 'right', width: '100px' }, sortable: true },
        { headerName: 'Order\nID', field: 'OrderID', headerSx: { textAlign: 'left', width: '100px' }, sortable: true },
        { headerName: 'Cancelled\nDate', field: 'CancelDate', headerSx: { textAlign: 'left', width: '100px' }, sortable: true },
        { headerName: 'Refund\nAmount', field: 'RefundAmount', headerSx: { textAlign: 'right', width: '100px' }, sortable: true },
        { headerName: 'Booking\nType', field: 'BookingType', headerSx: { textAlign: 'left', width: '100px' }, sortable: true },
        { headerName: 'Status', field: 'BookingStatus', headerSx: { textAlign: 'left', width: '100px' }, sortable: true },
        { headerName: 'Action', field: 'Action', headerSx: { textAlign: 'left', width: '100px' }, },
    ]
    return (
        <CustomizedDialogs
            open={open}
            titleText={titleText}
            width={'100%'}
            height={'auto'}
            onClose={onClose}
            padding={'0px'}
        >
            <Box className=' scrollBlueV6' maxHeight={'78vh'} sx={{
                overflowY: 'auto',
            }}>
                <Box sx={{
                    padding: "12px 16px"

                }}>

                    <TableContainer component={Paper} sx={{
                        boxShadow: 'none', border: '1px solid #0000001A',

                    }}>
                        <Table stickyHeader size="small" aria-label="a dense table"
                            sx={{
                                '.MuiTableCell-root': {
                                    padding: '12px 4px'
                                },
                                '.MuiTableCell-root:first-of-type': {
                                    pl: '12px',
                                },
                                '.MuiTableCell-root:last-of-type': {
                                    pr: '12px',
                                },
                            }}
                        >
                            <TableHead style={{ position: `sticky`, top: `0`, zIndex: '3' }}>
                                <TableRow>
                                    {columnDef.map((col, index) => (
                                        <TableCell key={`UnutilizedPyt-Table-header-${index}`}
                                            sx={{
                                                ...col?.headerSx,
                                                backgroundColor: '#E5F3FF',
                                                color: '#202020',
                                                fontWeight: 600,
                                                fontStyle: 'SemiBold',
                                                fontSize: '14px',
                                                lineHeight: '20px',
                                                letterSpacing: '0%',
                                                whiteSpace: 'pre-line',
                                                verticalAlign: 'top'

                                            }}
                                        >{col?.headerName}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.length > 0 ? data?.map((obj) => (
                                    <TableRow
                                        sx={{
                                            '&:last-child td, &:last-child th': { borderBottom: 'none' },
                                        }}
                                    >
                                        {columnDef?.map((col) => {
                                            return (
                                                col.field === "Action" ?
                                                    <TableCell
                                                        sx={{
                                                            ...col?.headerSx,
                                                            overflowWrap: 'break-word',
                                                        }}
                                                    >
                                                        <MButton btnName='Select' className='btn-orange28 ' onClick={() => {
                                                            handleLoad('P', obj.BookingID)
                                                        }} />
                                                    </TableCell>
                                                    :
                                                    <TableCell
                                                        sx={{
                                                            ...col?.headerSx,
                                                            overflowWrap: 'break-word',
                                                        }}
                                                    >{obj?.[col?.field] || ''}</TableCell>
                                            )
                                        })}
                                    </TableRow>
                                )) :
                                    <TableRow>
                                        <TableCell sx={{ textAlign: "center" }} colSpan={columnDef?.length}>No Record</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </CustomizedDialogs>
    )
}

export default BookingTableModal